import React, { Component } from 'react';
import { getData } from '@api/home';
// import { Card, Modal, Button } from 'antd';
// import LineDiagram from '@components/Charts/LineDiagram';
// import RadioBtnGroup from '@components/RadioBtnGroup';
// import DateGroup from '@components/DateGroup';
// import FormSummary from '@components/FormSummary';
import { formatDate } from '@utils/tool';
import bus from '@utils/bus';

export default class Home extends Component {
    formRef = React.createRef();

    state = {
        btns: [
            { key: 'new', val: '新增' }, 
            { key: 'sharenew', val: '分享新增' },
            { key: 'sharerate', val: '分享系数' },
            { key: 'dau', val: '活跃' },
            { key: 'paynum', val: '付费人数' },
        ],
        _isMounted: true,
        echartsOptions: {
            feilds: {
                'pirate-minigame': '海盗来了'
            },
            dataset: {
                dimensions: ['date', 'pirate-minigame'],
                source: []
            }
        },
        dateBtns: [
            { key: 'anytime', val: '实时' },
            { key: '0', val: '今天' },
            { key: '-1', val: '昨天' },
            { key: '7', val: '7天' },
            { key: '30', val: '30天' },
        ],
        dateDefaultValue: '7',
        formItems: [
            { key: 'user', label: '用户名', require: true, componentName: 'input', message: '请填写用户名', options: [] },
            { key: 'phone', label: '手机号', require: true, componentName: 'input', message: '请填写手机号', options: [] },
            { key: 'sele', label: '选择', require: true, componentName: 'select', message: '请填写', options: [{ value: 'zhangsan', label: '张三' }, { value: 123, label: '123' }] }
        ],
        visible: false,
        operateType: '',
        editDefaultValue: {}
    };

    componentWillUnmount () {
        this.setState({ _isMounted: false });
    };

    componentDidMount() {
        this.setState({ _isMounted: true }, () => {
            // this.handelGetData();
        });
    };

    getCurrentTimeFormat(time) {
        // return formatDate(time * 1000, 'hh:mm');
       return formatDate(time * 1000, 'yyyy-MM-dd');
    };

    handleChartsData(data) {
        let tempData = [];

        for (const datekey in data) {
            let itemjson = { date: this.getCurrentTimeFormat(datekey) }
            const items = data[datekey] || [];
            
            items.forEach(ele => {
                let elejson = {};

                elejson[ele.gameId] = ele.new;
                Object.assign(itemjson, elejson);
            });
            tempData.push(itemjson);
        }
        
        return tempData;
    };

    handelGetData() {
        const params = {
            'begin': 1542124800,
            'end': 1542816000,
            'gameIds': 'pirate-minigame',
            'field': 'new'
        }
        getData(params).then(res => {
            if (this.state._isMounted) {
                const tempData = res.data.data.data || [];
                let temp = this.state.echartsOptions;

                temp.dataset.source = this.handleChartsData(tempData);
                this.setState({
                    echartsOptions: temp
                });
                bus.dispatch('echarts_line');
            }
        })
    };

    handleRadioBtnChange = (data) => {
        console.log('btn change', data);
    };

    onDateChange = (data, btntag) => {
        this.setState({ dateDefaultValue: btntag });
    };

    handleOk = async (e) => {
        let demo = this.formRef.current;
        try {
            const values = await demo.validateFields();
            this.setState({
                visible: false
            });
            console.log(values); // 这里可以拿到数据
        } catch (err) {
            console.log(err);
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false
        });
    };

    showModal = () => {
        this.setState({
            visible: true,
            operateType: 'create',
            editDefaultValue: {}
        });
    };

    testClick = () => {
        this.setState({ visible: true });
        setTimeout(() => {
            let demo = this.formRef.current;

            demo.setFieldsValue({
                user: 'yanlizhi',
                phone: '10010',
                sele: 'zhangsan'
            });
        }, 0);
    };

    render() {
        return (
            // <div>
            //     <Button type="primary" onClick={this.showModal}>
            //         表单弹窗
            //     </Button>
            //     <Button type="primary" onClick={this.testClick}>
            //         编辑
            //     </Button>
            //     <Modal
            //     title="创建"
            //     visible={this.state.visible}
            //     onOk={this.handleOk}
            //     onCancel={this.handleCancel}
            //     >
            //         <FormSummary 
            //         ref={this.formRef} 
            //         formItems={this.state.formItems} />
            //     </Modal>
            //     <DateGroup onDateChange={this.onDateChange} btns={this.state.dateBtns} defaultValue={this.state.dateDefaultValue} />
            //     <RadioBtnGroup onChange={this.handleRadioBtnChange} defaultValue="new" btns={this.state.btns} /> 
            //     <Card
            //     title="统计"
            //     extra={<span>More</span>}
            //     style={{width: '100%', marginTop: 10 }}>
            //         <LineDiagram options={this.state.echartsOptions} />
            //     </Card>
            // </div>
            <div>
                <h2 style={{marginTop: 8}}>欢迎进入渠道商户后台</h2>
                <h4 style={{marginTop: 16}}>更多权限请联系管理员</h4>
            </div>
        );
    } 
}